import React, { useEffect, useState } from "react";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import api from "../../api/axios";
import Swal from "sweetalert2";

const AddDesingnationModelPopup = ({
  designation,
  company_id,
  filteredData,
  setIsModalOpen,
  isModalOpen,
  isEditModalOpen,
  setIsEditModalOpen,
}) => {
  const [departmentID, setDepartmentID] = useState("");
  const [designationName, setDesignationName] = useState("");
  const [designationAbbr, setDesignationAbbr] = useState("");
  const [departmentError, setDepartmentError] = useState("");
  const [designationERror, setDesignationError] = useState("");
  const [designationAbbrError, setDesignationAbbrError] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    setDepartmentID(filteredData[0]?.department_id || "");
    setDesignationName(filteredData[0]?.designation_name || "");
    setDesignationAbbr(filteredData[0]?.designation_abbreviation || "");
  }, [filteredData]);

  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? "#ff9b44" : "#fff",
      color: state.isFocused ? "#fff" : "#000",
      "&:hover": {
        backgroundColor: "#ff9b44",
      },
    }),
  };

  const submitDesignation = async (e) => {
    e.preventDefault();
    if (!departmentID) {
      setDesignationError("");
      setDepartmentError("* Please Enter Designation Name !");
      return;
    }
    if (!designationName) {
      setDepartmentError("");
      setDesignationError("* Please Select the Department Name !");
      return;
    }
    if (!designationAbbr) {
      setDesignationAbbrError("* Please Enter Designation abbreviation !");
      return;
    }
    setDesignationError("");
    setDepartmentError("");
    setDesignationAbbrError("");
    try {
      const res = await api.post(`department/addDesignation/${company_id}`, {
        departmentID,
        designationName,
        designationAbbr,
      });
      if (res?.data?.existingAbbr === true) {
        setDesignationAbbrError(`* ${res?.data?.message}`);
        return;
      }
      if (res?.data?.success === true) {
        Swal.fire({
          title: "Designation Added",
          icon: "success",
          confirmButtonText: "OK",
          timer: 2000,
          timerProgressBar: true,
          customClass: {
            confirmButton: "btn btn-primary",
          },
        });
        navigate("../designations");
        setDesignationName("");
        setDepartmentID("");
      }
    } catch (err) {
      setIsModalOpen(false);
      Swal.fire({
        text: "Something went wrong, please try again later.",
        icon: "warning",
        confirmButtonText: "OK",
        timer: 2000,
        timerProgressBar: true,
        customClass: {
          confirmButton: "btn btn-warning",
        },
      });
      console.error(err);
    }
  };

  const updateDesignationHandler = async (e) => {
    e.preventDefault();
    const department_id = departmentID
      ? departmentID
      : filteredData[0]?.department_id;
    const designation_name = designationName
      ? designationName
      : filteredData[0]?.designation_name;
    const designation_id = filteredData[0]?.designation_id;

    if (!department_id) {
      setDepartmentError("Department is Required !");
      setDesignationError("");
      return;
    }
    if (!designation_name) {
      setDepartmentError("");
      setDesignationError("Designation is Required!");
      return;
    }
    setDepartmentError("");
    setDesignationError("");
    try {
      const res = await api.put(
        `department/designation-update/company/${company_id}`,
        {
          department_id,
          designation_name,
          designation_id,
          designationAbbr,
        }
      );
      if (res?.data?.existingAbbr === true) {
        setDesignationAbbrError(`* ${res?.data?.message}`);
        return;
      }
      if (res?.data?.success === true) {
        Swal.fire({
          title: "Designation Updated",
          icon: "success",
          confirmButtonText: "OK",
          timer: 2000,
          timerProgressBar: true,
          customClass: {
            confirmButton: "btn btn-primary",
          },
        });
        navigate("../designations");
        setDesignationName("");
        setDepartmentID("");
      }
    } catch (err) {
      setIsEditModalOpen(false);
      Swal.fire({
        text: "Something went wrong, please try again later.",
        icon: "warning",
        confirmButtonText: "OK",
        timer: 2000,
        timerProgressBar: true,
        customClass: {
          confirmButton: "btn btn-warning",
        },
      });
      console.error(err);
    }
  };

  const handleDiscardChanges = () => {
    navigate("../designations");
    setIsModalOpen(false);
  };

  const resetData = () => {
    setDesignationName("");
    setDepartmentID("");
    setDesignationAbbr("");
  };

  const resetError = () => {
    setDepartmentError("");
    setDesignationAbbrError("");
    setDesignationError("");
  };

  useEffect(() => {
    resetData();
    resetError();
  }, [isModalOpen]);

  useEffect(() => {
    resetError();
  }, [isEditModalOpen]);

  const closeEditModal = () => {
    setIsEditModalOpen(false);
  };

  return (
    <>
      <div
        id="add_designation"
        className={`modal custom-modal fade ${
          isModalOpen ? "show d-block" : ""
        }`}
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Add Designation</h5>
              <button
                type="button"
                className="btn-close"
                onClick={handleDiscardChanges}
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <form onSubmit={submitDesignation}>
                <div>
                  <div className="input-block mb-3">
                    <label className="col-form-label">
                      Department <span className="text-danger">*</span>
                    </label>

                    <Select
                      options={designation}
                      placeholder="Select Department"
                      styles={customStyles}
                      onChange={(department) =>
                        setDepartmentID(department.value)
                      }
                    />
                    {departmentError && (
                      <span className="text-danger">{departmentError}</span>
                    )}
                  </div>
                  <div className="input-block mb-3">
                    <label className="col-form-label">
                      Designation Name <span className="text-danger">*</span>
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      value={designationName}
                      onChange={(e) => setDesignationName(e.target.value)}
                    />
                    {designationERror && (
                      <span className="text-danger">{designationERror}</span>
                    )}
                  </div>
                  <div className="input-block mb-3">
                    <label className="col-form-label">
                      Designation abbreviation{" "}
                      <span className="text-danger">*</span>
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      value={designationAbbr}
                      onChange={(e) => {
                        setDesignationAbbrError("");
                        setDesignationAbbr(e.target.value);
                      }}
                    />
                    {designationAbbrError && (
                      <span className="text-danger">
                        {designationAbbrError}
                      </span>
                    )}
                  </div>
                  <div className="submit-section">
                    <button
                      disabled={
                        designationName && designationAbbr && designationName
                          ? false
                          : true
                      }
                      className="btn btn-primary submit-btn"
                      type="submit"
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <div
        id="edit_designation"
        className={`modal custom-modal fade ${
          isEditModalOpen ? "show d-block" : ""
        }`}
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Edit Designation</h5>
              <button
                type="button"
                className="btn-close"
                onClick={closeEditModal}
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <form onSubmit={updateDesignationHandler}>
                <div className="input-block mb-3">
                  <label className="col-form-label">
                    Department <span className="text-danger">*</span>
                  </label>

                  <select
                    className="form-select"
                    styles={customStyles}
                    placeholder="Select"
                    name="department"
                    value={departmentID}
                    onChange={(e) => {
                      setDepartmentID(e.target.value);
                    }}
                  >
                    <option value="">Select Department</option>
                    {designation.map((item) => (
                      <option value={item.value} key={item.value}>
                        {item.label}
                      </option>
                    ))}
                  </select>
                  {departmentError && (
                    <span className="text-danger">{departmentError}</span>
                  )}
                </div>
                <div className="input-block mb-3">
                  <label className="col-form-label">
                    Designation Name <span className="text-danger">*</span>
                  </label>
                  <input
                    className="form-control"
                    type="text"
                    value={designationName}
                    onChange={(e) => setDesignationName(e.target.value)}
                  />
                  {departmentError && (
                    <span className="text-danger">{departmentError}</span>
                  )}
                </div>
                <div className="input-block mb-3">
                  <label className="col-form-label">
                    Designation abbreviation{" "}
                    <span className="text-danger">*</span>
                  </label>
                  <input
                    className="form-control"
                    type="text"
                    value={designationAbbr}
                    onChange={(e) => {
                      setDesignationAbbrError("");
                      setDesignationAbbr(e.target.value);
                    }}
                  />
                  {designationAbbrError && (
                    <span className="text-danger">{designationAbbrError}</span>
                  )}
                </div>
                <div className="submit-section">
                  <button
                    disabled={
                      designationName && designationAbbr && designationName
                        ? false
                        : true
                    }
                    className="btn btn-primary submit-btn"
                    type="submit"
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddDesingnationModelPopup;
